import { render } from "./BoundingBoxes.vue?vue&type=template&id=6c0d9781&scoped=true"
import script from "./BoundingBoxes.vue?vue&type=script&lang=js"
export * from "./BoundingBoxes.vue?vue&type=script&lang=js"

import "./BoundingBoxes.vue?vue&type=style&index=0&id=6c0d9781&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0d9781"]])

export default __exports__